import { defineMessages } from 'react-intl';

const messages = defineMessages({
  saveButton: {
    description: 'branding modal save button',
    defaultMessage: 'Save',
    id: '8enmW6',
  },
  cancelButton: {
    description: 'branding modal cancel button',
    defaultMessage: 'Cancel',
    id: 'EXjJmR',
  },
});

export default messages;
